<template>
    <div class="row first-step">
        <div class="col-md-6"></div>
        <div class="info-panel" :style="cssProps">
            <!-- <base-logo class="logo-position-right"></base-logo> -->
            <!-- <div class="info-panel-body py-5 px-4">
                <h4>
                    GROWTH FOR YOUR<br /><span class="span-invest"
                        >INVESTMENTS</span
                    ><br />JUST A CLICK AWAY!
                </h4>

                <ul>
                    <li>
                        <span class="icon-check_circle"></span>Open your Digital
                        Sahulat Sarmayakari account to invest in mutual funds.
                    </li>
                    <li>
                        <span class="icon-check_circle"></span>Single
                        Transaction Limit Rs.400,000/-
                    </li>
                    <li>
                        <span class="icon-check_circle"></span>Annual
                        Transaction Limit Rs.800,000/-
                    </li>
                    <li>
                        <span class="icon-check_circle"></span>Cumulative
                        Transaction Limit Rs.1,000,000/-
                    </li>
                </ul>
            </div> -->
        </div>
        <!-- <div class="col-md-6 col-xs-12 p-0">
            <div class="info-panel" :style="cssProps">
                <base-logo class="logo-position-left"></base-logo>
                <div class="info-panel-body py-5 px-4 text-center">
                    <p class="f-22">Your bright future, just a few steps away!</p>

                    <ul>
                        <li>Your bright future, just a few steps away!</li>
                        <li>Keep your cnic and account details handy</li>
                    </ul>
                </div>
            </div>

            <div class="color-overlay"></div>
        </div> -->
        <div class="col-md-6 col-xs-12 p-0 max-height-100">
            <div class="row justify-content-center">
                <div class="col-lg-9">
                    <base-logo
                        class="main-logo logo-style for-tablet-mobile"
                    ></base-logo>
                    <b-form class="step-form" @submit.stop.prevent="onSubmit">
                        <div class="login-panel custom-p-5">
                            <div class="">
                                <div class="lang-row">
                                    <a
                                        href=""
                                        :class="{
                                            'selected-lang':
                                                selectedLang == 'en',
                                        }"
                                        class="eng-text"
                                        @click.prevent="selectedLang = 'en'"
                                        >English</a
                                    >
                                    <a
                                        href=""
                                        :class="{
                                            'selected-lang':
                                                selectedLang == 'urd',
                                        }"
                                        class="urdu-text"
                                        @click.prevent="selectedLang = 'urd'"
                                    >
                                        اردو</a
                                    >
                                </div>
                                <h2>Register Your Account!</h2>
                                <p class="para">
                                    For the purpose of industry regulation, your
                                    details are required.
                                </p>
                                <!-- <div class="d-flex">
                  <div class="system-user-warning">
                    <i class="icon-error_outline"></i>
                  </div>
                  <div class="system-user-details">
                    <p>
                      We will send you an email to create your new
                      password.
                    </p>
                  </div>
                </div> -->
                                <!-- selectedLang == 'English' ? 'ID Document Type' : 'شناختی دستاویز کی قسم' -->
                                <div
                                    :class="{
                                        'urdu-text': selectedLang == 'urd',
                                    }"
                                >
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <b-form-group
                                                id="input-group-1"
                                                :label="
                                                    getLabel('ID Document Type')
                                                "
                                                label-for="document-type"
                                                class="required-field"
                                            >
                                                <b-form-select
                                                    id="document-type"
                                                    v-model="
                                                        formData.documentType
                                                    "
                                                    v-validate="{
                                                        required: true,
                                                    }"
                                                    :options="
                                                        documentTypeOptions
                                                    "
                                                    name="document type"
                                                    class="form-control"
                                                    :class="{
                                                        'is-invalid':
                                                            errors.has(
                                                                'document type'
                                                            ),
                                                    }"
                                                    @change="onChange"
                                                >
                                                    <option
                                                        slot="first"
                                                        :value="null"
                                                        disabled
                                                    >
                                                        Select ID Document Type
                                                    </option>
                                                </b-form-select>
                                            </b-form-group>
                                        </div>
                                        <div class="col-lg-6">
                                            <b-form-group
                                                id="input-group-1"
                                                :label="getLabel('cnic/nicop')"
                                                label-for="cnic nicop"
                                                class="required-field"
                                            >
                                                <div
                                                    v-if="
                                                        formData.documentType !==
                                                        'passport'
                                                    "
                                                >
                                                    <masked-input
                                                        v-model="formData.cnic"
                                                        v-validate="{
                                                            required: true,
                                                            max: 15,
                                                            min: 13,
                                                        }"
                                                        placeholder="Enter CNIC/NICOP"
                                                        mask="11111-1111111-1"
                                                        name="cnic/nicop"
                                                        :class="{
                                                            'is-invalid':
                                                                errors.has(
                                                                    'cnic/nicop'
                                                                ),
                                                        }"
                                                        class="form-control"
                                                        autocomplete="no"
                                                    />
                                                </div>
                                                <div v-else>
                                                    <b-form-input
                                                        id="cnic"
                                                        v-model="formData.cnic"
                                                        v-validate="{
                                                            required: true,
                                                            alpha_num,
                                                            max: 9,
                                                            min: 9,
                                                        }"
                                                        type="text"
                                                        name="cnic"
                                                        autocomplete="no"
                                                        class="form-control"
                                                        placeholder="Enter CNIC/NICOP"
                                                        :class="{
                                                            'is-invalid':
                                                                errors.has(
                                                                    'cnic/nicop'
                                                                ),
                                                        }"
                                                        @keypress="onInput"
                                                    ></b-form-input>
                                                </div>

                                                <!-- -->
                                            </b-form-group>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-6">
                                            <date-picker
                                                :field="cnicIssueDateFieldConfig"
                                                :data-segment-id="
                                                    formData.formType ||
                                                    dataSegmentId
                                                "
                                            ></date-picker>
                                        </div>
                                        <div class="col-lg-6">
                                            <date-picker
                                                :field="dateOfBirthFieldConfig"
                                                :data-segment-id="
                                                    formData.formType ||
                                                    dataSegmentId
                                                "
                                            ></date-picker>
                                        </div>
                                    </div>

                                    <!--
                                    Legacy native date inputs (reference only; same fields now use DatePicker above).
                                    Previously also used formData.cnicIssueDate / formData.dateOfBirth and onSubmit commits.

                                    <div class="row">
                                        <div class="col-lg-6">
                                            <b-form-group
                                                id="input-group-cnic-issue"
                                                :label="getLabel('CNIC Issue Date')"
                                                label-for="cnic-issue-date"
                                                class="required-field"
                                            >
                                                <b-form-input
                                                    id="cnic-issue-date"
                                                    v-model="formData.cnicIssueDate"
                                                    v-validate="{ required: true }"
                                                    type="date"
                                                    name="cnic issue date"
                                                    :max="todayIsoDate"
                                                    class="form-control"
                                                    :class="{
                                                        'is-invalid': errors.has('cnic issue date'),
                                                    }"
                                                    autocomplete="off"
                                                ></b-form-input>
                                            </b-form-group>
                                        </div>
                                        <div class="col-lg-6">
                                            18+ years max DOB (commented: enable by uncommenting
                                            maxDateOfBirthIso in computed and using :max="maxDateOfBirthIso" on the input):
                                            :max="maxDateOfBirthIso"
                                            <b-form-group
                                                id="input-group-dob"
                                                :label="getLabel('Date of Birth')"
                                                label-for="date-of-birth"
                                                class="required-field"
                                            >
                                                <b-form-input
                                                    id="date-of-birth"
                                                    v-model="formData.dateOfBirth"
                                                    v-validate="{ required: true }"
                                                    type="date"
                                                    name="date of birth"
                                                    :max="todayIsoDate"
                                                    class="form-control"
                                                    :class="{
                                                        'is-invalid': errors.has('date of birth'),
                                                    }"
                                                    autocomplete="bday"
                                                ></b-form-input>
                                            </b-form-group>
                                        </div>
                                    </div>
                                    -->

                                    <!-- <div class="row"> -->
                                    <!-- <div class="col-lg-4"> -->
                                    <b-form-group
                                        id="input-group-1"
                                        :label="
                                            getLabel(
                                                'Full Name (as per Identity Document)'
                                            )
                                        "
                                        label-for="full-name"
                                        class="required-field"
                                    >
                                        <div class="">
                                            <b-form-input
                                                id="full-name"
                                                v-model="formData.fullName"
                                                v-validate="{
                                                    required: true,
                                                    max: 100,
                                                    alpha_spaces,
                                                }"
                                                name="full name"
                                                type="text"
                                                :class="{
                                                    'is-invalid':
                                                        errors.has('full name'),
                                                }"
                                                autocomplete="no"
                                                placeholder="Enter full name (as per Identity Document)"
                                            ></b-form-input>
                                        </div>
                                    </b-form-group>

                                    <b-form-group
                                        id="input-group-1"
                                        :label="getLabel('Email Address')"
                                        label-for="email-address"
                                        class="required-field"
                                    >
                                        <b-form-input
                                            id="email-address"
                                            v-model.trim="formData.email"
                                            v-validate="{
                                                required: true,
                                                email: true,
                                            }"
                                            name="email"
                                            :class="{
                                                'is-invalid':
                                                    errors.has('email'),
                                            }"
                                            autocomplete="no"
                                            placeholder="Enter email address (xxxx@xxx.xxx)"
                                        ></b-form-input>
                                    </b-form-group>

                                    <phone-number
                                        :field="phoneNumberField"
                                        :data-segment-id="dataSegmentId"
                                        :selected-language="selectedLang"
                                    ></phone-number>

                                    <b-form-group
                                        id="input-group-1"
                                        :label="
                                            getLabel('Referral Code (if any)')
                                        "
                                        label-for="referral-code"
                                    >
                                        <b-form-input
                                            id="referral-code"
                                            v-model="formData.refCode"
                                            v-validate="{
                                                numeric,
                                            }"
                                            name="referral code"
                                            :class="{
                                                'is-invalid':
                                                    errors.has('referral code'),
                                            }"
                                            autocomplete="no"
                                            placeholder="Enter referral code (if any)"
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        id="input-group-1"
                                        :label="getLabel('Account Type')"
                                        label-for="account-type"
                                        class="required-field kyc-status-radio overwrite-radio"
                                    >
                                        <b-form-radio-group
                                            id="account-type"
                                            v-model="formData.formType"
                                            v-validate="{
                                                required: true,
                                            }"
                                            :options="options"
                                            name="account type"
                                            :class="{
                                                'is-invalid':
                                                    errors.has('account type'),
                                            }"
                                            class=""
                                            @input="setDataSegmentId"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>
                                <span
                                    v-if="isError"
                                    class="text-center color-red"
                                    >{{ isError }}</span
                                >
                            </div>
                            <div class="action-buttons">
                                <base-button
                                    btn-label="Continue"
                                    btn-type="submit"
                                    btn-variant="primary"
                                    class="width-100"
                                    :class="loading ? 'disabled' : ''"
                                ></base-button>
                                <!-- <base-button
                    btn-label="Cancel   "
                    btn-type="reset"
                    :disabled="loading"
                    btn-variant="link"
                ></base-button> -->
                            </div>
                        </div>
                    </b-form>
                    <base-footer style="position: static"></base-footer>
                </div>
            </div>
        </div>
        <b-modal
            id="alreadyRegisteredModal"
            ref="alreadyRegisteredModal"
            size="sm"
            title=""
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <message-modal
                title="CNIC already exists!"
                :message="NotAllowRegisterMesssage"
                @close="closeMessageModal()"
            ></message-modal>
        </b-modal>
        <b-modal
            ref="otpmodal"
            size="sm"
            title=""
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            @close="onCloseOTPModal"
        >
            <otp-verification-modal
                :data="otpData"
                @verificationStatus="otpResponse"
                @reSendOTP="reSendOTP"
            ></otp-verification-modal>
        </b-modal>
        <b-modal
            ref="newcustomerpopup"
            size="sm"
            title=""
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            @close="onCloseOTPModal"
        >
            <new-customer-popup
                :data="responseData"
                @agreed="newCustomerPopup"
            ></new-customer-popup>
        </b-modal>
        <b-modal
            ref="languageselectpopup"
            size="sm"
            title=""
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <language-select-popup
                @agreed="languageSelectPopup"
            ></language-select-popup>
        </b-modal>

        <b-modal
            ref="comingsoonpopup"
            size="sm"
            title=""
            hide-footer
            hide-header-close
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <coming-soon-popup @agreed="comingSoonPopup"></coming-soon-popup>
        </b-modal>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'
import resource from '@/api/resource'
import axios from 'axios'

const viewBrandingApi = new resource('configurations/branding')
import IdentityType from '@/components/registration/IdentityType.vue'
import PhoneNumber from '@/components/registration/PhoneNumber.vue'
import DatePicker from '@/components/registration/DatePicker.vue'
import OtpVerificationModal from '../../components/registration/OtpVerificationModal'
import NewCustomerPopup from '../../components/registration/NewCustomerPopup'
import LanguageSelectPopup from '../../components/registration/LanguageSelectPopup'
import ComingSoonPopup from '../../components/registration/ComingSoonPopup'
import MaskedInput from 'vue-masked-input'
import MessageModal from '../../components/registration/MessageModal.vue'
const apiUrl = process.env.VUE_APP_API_URL
export default {
    inject: ['mixpanel'],
    components: {
        OtpVerificationModal,
        PhoneNumber,
        DatePicker,
        MaskedInput,
        // eslint-disable-next-line vue/no-unused-components
        IdentityType,
        NewCustomerPopup,
        LanguageSelectPopup,
        ComingSoonPopup,
        MessageModal,
    },
    data() {
        return {
            selectedLang: 'en',
            otpData: null,
            responseData: null,
            languageOption: null,
            hasSahulatAccount: false,
            hasRegularAccount: false,
            isRegisterationAllowed: true,
            formData: {
                email: null,
                number: null,
                cnic: null,
                fullName: null,
                pNumber: null,
                // middleName: '',
                // lastName: null,
                formType: null,
                refCode: null,
                genders: null,
                otpCode: null,
                dataSegmentId: null,
                documentType: null,
            },
            tempData: {},
            options: [
                {
                    text: 'Regular Digital Account',
                    value: process.env.VUE_APP_RC_ACCOUNT,
                },
                {
                    text: 'Sahulat Sarmayakari Account',
                    value: process.env.VUE_APP_SSA_ACCOUNT,
                },
            ],

            documentTypeOptions: [
                {
                    text: 'National ID Card',
                    value: 'id',
                },
                {
                    text: 'National Identity Card for Overseas Pakistanis',
                    value: 'nicop',
                },
                // {
                //     text: 'Passport',
                //     value: 'passport',
                // },
                {
                    text: 'Pakistan Origin Card',
                    value: 'poc',
                },
                {
                    text: 'National Alien Registration System',
                    value: 'arc',
                },
            ],

            // formData: this.initializeFormData(),
            // dataSegments: [],
            // selectedSegIds: [],
            cssProps: {
                // backgroundImage: `url(${require('@/assets/images/image-banner-1-1.png')})`,
                background: `url(${require('@/assets/images/image-banner-new.jpg')}) center`,
                // backgroundSize: `cover`,
                // backgroundSize: `contain`
            },

            phoneNumberField: {
                association: null,
                isRequired: true,
                isLocked: true,
                status: 'active',
                isEmail: false,
                isNumeric: true,
                _id: '60883b658735784e005ca7b5',
                dataSegmentId: '60bddf249820642a02485773',
                section: 'setup-profile',
                sectionTitle: 'Setup Profile',
                type: 'phone-number',
                sequenceNumber: 34,
                title: 'Phone Number',
                label: 'Phone Number',
                placeholder: 'Enter phone number',
                options: [],
                key: 'contactInfo.phoneNumber',
                createdAt: '2021-06-10T17:32:51.341Z',
                updatedAt: '2021-06-10T17:32:51.341Z',
                __v: 0,
                maxLength: 10,
                minLength: 10,
                isAlphaNum: false,
                isAlpha: false,
                id: '60883b658735784e005ca7b5',
                description: '',
            },
            labels: [
                {
                    english: 'ID Document Type',
                    urdu: 'شناختی دستاویز کی قسم',
                },
                {
                    english: 'cnic/nicop',
                    urdu: 'شناختی دستاویز نمبر',
                },
                {
                    english: 'CNIC Issue Date',
                    urdu: 'شناختی کارڈ کی تاریخ اجراء',
                },
                {
                    english: 'Date of Birth',
                    urdu: 'تاریخ پیدائش',
                },
                {
                    english: 'Full Name (as per Identity Document)',
                    urdu: 'پورا نام (شناختی دستاویز کے مطابق)',
                },
                {
                    english: 'Email Address',
                    urdu: 'ای میل اڈریس',
                },
                {
                    english: 'Phone Number',
                    urdu: 'فون نمبر',
                },
                {
                    english: 'Referral Code (if any)',
                    urdu: 'ریفرل کوڈ (اگر کوئی ہو)',
                },
                {
                    english: 'Account Type',
                    urdu: 'اکاؤنٹ کی اقسام',
                },
            ],
        }
    },

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        dataSegmentId() {
            window.fbq('track', 'PageView')
            // if (this.$route.params.dataSegmentId) {
            //     return this.$route.params.dataSegmentId
            // }

            // return this.$store.getters.dataSegmentId
            return process.env.VUE_APP_SSA_ACCOUNT
        },
        // selectedLang(){
        //     this.switchLanguage()
        // }
        // Legacy native type="date" max values (reference only; DatePicker uses DatePicker.vue rules)
        // todayIsoDate() {
        //     return new Date().toISOString().slice(0, 10)
        // },
        // 18+ years validation for date of birth (commented: swap DOB max to use this if using native input)
        // maxDateOfBirthIso() {
        //     const d = new Date()
        //     d.setFullYear(d.getFullYear() - 18)
        //     return d.toISOString().slice(0, 10)
        // },
        cnicIssueDateFieldConfig() {
            let label = 'CNIC Issue Date'
            if (this.selectedLang === 'urd') {
                const found = this.labels.find(
                    (e) => e.english === 'CNIC Issue Date'
                )
                if (found) {
                    label = found.urdu
                }
            }
            return {
                key: 'identityInfo.IssuanceDate',
                isLocked: true,
                isRequired: true,
                _id: 'initform-cnic-issue',
                label,
                type: 'date-picker',
            }
        },
        dateOfBirthFieldConfig() {
            let label = 'Date of Birth'
            if (this.selectedLang === 'urd') {
                const found = this.labels.find(
                    (e) => e.english === 'Date of Birth'
                )
                if (found) {
                    label = found.urdu
                }
            }
            return {
                key: 'basicInfo.dateOfBirth',
                isLocked: true,
                isRequired: true,
                _id: 'initform-dob',
                label,
                type: 'date-picker',
            }
        },
        allowRegister() {
            console.log('this.formData.formType : ', this.formData.formType)
            console.log(
                'process.env.VUE_APP_SSA_ACCOUNT : ',
                process.env.VUE_APP_SSA_ACCOUNT
            )
            let hasSelectedSahulatAccount =
                this.formData.formType == process.env.VUE_APP_SSA_ACCOUNT

            return this.hasRegularAccount
                ? false
                : this.hasSahulatAccount && hasSelectedSahulatAccount
                ? false
                : true
        },
        NotAllowRegisterMesssage() {
            return "An account is already registered with the provided CNIC."
            // return this.hasRegularAccount
            //     ? 'For further details kindly contact at ir@jsil.com'
            //     : this.hasSahulatAccount
            //     ? 'Your CNIC is already registered in Sahulat account. For further details kindly contact at ir@jsil.com'
            //     : ''
        },
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    mounted() {
        this.getBrandingData()
        localStorage.setItem(
            'activeDataSegmentId',
            process.env.VUE_APP_SSA_ACCOUNT
        )
        this.$store.dispatch("trackEvent", {event: 'JS | Signup Page'})
        // this.$store.commit('initDefaultFields', 'form')
    }, // End of Component > watch

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        getLabel(label) {
            if (this.selectedLang == 'en') {
                return label
            } else if (this.selectedLang == 'urd') {
                let found = this.labels.find((e) => label == e.english)
                return found.urdu
            }
        },
        onInput(event) {
            if (this.documentType == 'passport') {
                let target = event.target.value

                if (target.length > 8) {
                    event.preventDefault()
                } else {
                    return true
                }
            }
        },
        onChange(event) {
            console.log(event)
            // if(event == 'passport'){
            this.formData.cnic = null
            // }
        },
        setDataSegmentId() {
            this.$store.commit('setDataSegmentId', this.formData.formType)
            localStorage.setItem('activeDataSegmentId', this.formData.formType)
            // if (this.formData.formType == process.env.VUE_APP_SSA_ACCOUNT) {
            //     // this.$refs.languageselectpopup.show()
            // } else if (
            //     this.formData.formType == process.env.VUE_APP_RC_ACCOUNT
            // ) {
            //     this.$refs.comingsoonpopup.show()
            // }
        },
        // languageSelectPopup() {
        //     this.languageOption =
        //         this.$store.state.registration.form.languageOption
        //     this.$refs.languageselectpopup.hide()
        // },
        comingSoonPopup() {
            this.formData.formType = null
            this.$refs.comingsoonpopup.hide()
        },
        async getBrandingData() {
            let { data } = await viewBrandingApi.list()
            this.$store.commit('setDisplaySetting', data.data)
        },
        /**
         * Request to check customer exists or not
         * */
        async registerTempCustomer() {
            this.$store.commit('setLoading', true)
            try {
                this.$store.commit('setLoading', true)

                const formData = this.$store.state.registration.form
                formData.dataSegmentId = this.formData.formType

                axios
                    .post(apiUrl + 'customers/temp-customer-register', formData)
                    .then((response) => {
                        /**
                         * Updating Mutations if Temp Customer Exists
                         */

                        if (response.data.data) {
                            let payload = response.data.data
                            if(payload && payload.accountInfo) {
                                payload.accountInfo.addNominee =  payload.accountInfo.addNominee || 'No'
                            }
                            this.tempData = payload

                            const initFormDob = this.$store.state.registration.form.basicInfo.dateOfBirth

                            this.$store.commit('setValue', {
                                key: 'form',
                                value: payload,
                            })

                            if (initFormDob) {
                                this.$store.commit('updateField', {
                                    key: 'basicInfo.dateOfBirth',
                                    value: initFormDob,
                                })
                            }

                            this.responseData = response.data
                            // this.$store.commit(
                            //     'setSuccess',
                            //     response.data.message
                            // )
                            /**
                             * Updating TempCustomerId
                             */
                            this.$store.commit('updateField', {
                                key: 'basicInfo.tempId',
                                value: response.data.data._id,
                            })

                            this.$refs.newcustomerpopup.show()
                            this.$refs.otpmodal.hide()

                            // window.location.href = process.env.VUE_APP_URL+"/"+this.dataSegmentId+"/register"

                            // this.$store.commit('setLoading', false)
                        } else {
                            console.log('error', response.data.message)
                            this.$store.commit('setLoading', false)
                            this.$store.commit(
                                'setError',
                                response.data.message
                            )
                            this.$refs.otpmodal.hide()
                        }
                    })
                    .catch((error) => {
                        this.errorMessage = error.message
                        this.$store.commit('setLoading', false)
                        this.$store.commit('setError', 'Something went wrong')
                        console.error('There was an error!', error)
                        this.$refs.otpmodal.hide()
                    })
            } catch (err) {
                console.log('Errorr ' + err)
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', 'Something went wrong')
            }
        },
        newCustomerPopup() {
            this.$store.commit('setLoading', true)
            this.$refs.newcustomerpopup.hide()

            if (this.selectedLang) {
                this.$store.commit('updateField', {
                    key: 'languageOption',
                    value: this.selectedLang,
                })
            }
            try {
                if (this.$route.meta.publicRegistration === true) {
                    if (
                        this.formData.formType == process.env.VUE_APP_RC_ACCOUNT
                    ) {
                        this.$router.push({
                            // name: 'public-registration-record-video',
                            name: 'public-registration-identity-document',
                            params: {
                                tempData: this.tempData,
                                languageOption: this.selectedLang,
                            },
                        })
                        // .catch(() => {
                        //     this.$router.push({
                        //         // name: 'public-registration-record-video',
                        //         name: 'public-registration-identity-document',
                        //         params: {
                        //             tempData: this.tempData,
                        //             languageOption: this.selectedLang,
                        //         },
                        //     })
                        // })
                    } else if (
                        this.formData.formType ==
                        process.env.VUE_APP_SSA_ACCOUNT
                    ) {
                        this.$router.push({
                            // name: 'public-registration-record-video',
                            name: 'public-registration-identity-document-ssa',
                            params: {
                                tempData: this.tempData,
                                languageOption: this.selectedLang,
                            },
                        })
                        // .catch(() => {
                        //     this.$router.push({
                        //         // name: 'public-registration-record-video',
                        //         name: 'public-registration-identity-document-ssa',
                        //         params: {
                        //             tempData: this.tempData,
                        //             languageOption: this.selectedLang,
                        //         },
                        //     })
                        // })
                    }
                    this.$store.commit('setLoading', false)
                } else {
                    // this.$router.push('/register-customer/record-video')
                    // this.$router.push('/register-customer/upload-document')
                    this.$router.push('/identity-document')
                    this.$store.commit('setLoading', false)
                }
            } catch (err) {
                console.log(err)
            }
        },
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            // validate the form fields
            this.formData.cnic = this.formData.cnic.replace(/-/g, '')

            if (this.formData.cnic.includes('_')) {
                this.formData.cnic = this.formData.cnic.replace(/_/g, '')
            }

            const result = await this.$validator.validateAll()

            // Check if validation fails
            if (result) {
                // this.$store.commit('setLoading', true)

                this.$store.commit('updateField', {
                    key: 'basicInfo.firstName',
                    value: this.formData.fullName,
                })

                this.$store.commit('updateField', {
                    key: 'contactInfo.email',
                    value: this.formData.email,
                })

                this.formData.pNumber =
                    this.$store.state.registration.form.contactInfo.phoneNumber

                this.$store.commit('updateField', {
                    key: 'contactInfo.phoneNumber',
                    value: this.formData.pNumber,
                })

                // this.$store.commit('updateField', {
                //     key: 'identityInfo.type',
                //     value: 'id',
                // })

                this.$store.commit('updateField', {
                    key: 'identityInfo.number',
                    value: this.formData.cnic,
                })

                // this.$store.commit('updateField', {
                //     key: 'dataSegmentId',
                //     value: this.formData.formType,
                // })

                this.$store.commit('updateField', {
                    key: 'basicInfo.refCode',
                    value: this.formData.refCode,
                })

                this.$store.commit('updateField', {
                    key: 'identityInfo.type',
                    value: this.formData.documentType,
                })
                // IssuanceDate & dateOfBirth: set via setup-profile DatePicker (store)
                // this.registerTempCustomer();

                const issuanceDate = this.$store.state.registration.form.identityInfo.IssuanceDate
                const dateOfBirth = this.$store.state.registration.form.basicInfo.dateOfBirth
                if (issuanceDate && dateOfBirth && issuanceDate < dateOfBirth) {
                    this.$store.commit('setError', 'CNIC Issue Date cannot be before Date of Birth')
                    return
                }

                await this.checkIfAccountAlreadyExists()

                if (!this.isRegisterationAllowed) {
                    this.$refs.alreadyRegisteredModal.show()
                    return
                }

                this.sendOPT()
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method

        async checkIfAccountAlreadyExists() {
            try {
                this.$store.commit('setLoading', true)
                let formData = {
                    nic_passport: this.formData.cnic,
                    account_type : this.formData.formType
                }
                
                let { data } = await axios.post(
                    '/api/configurations/verify-account-from-cnic',
                    formData
                )

                if (data && data.data !== null) {
                     if (data.status === 'failed') {
                        this.isRegisterationAllowed = false
                    } else {
                        this.isRegisterationAllowed = true
                    }            
                } 
                else 
                {
                    console.log('resp err data', data)
                    console.log('error', data.message)
                    this.$store.commit('setLoading', false)
                    // this.$store.commit(
                    //     'setError',
                    //     data.message
                    // )
                }

                this.$store.commit('setLoading', false)
            } catch (err) {
                console.log('Errorr ' + err)
                this.$store.commit('setLoading', false)
                // this.$store.commit('setError', 'Something went wrong')
            }
        }, // End of checkIfAccountAlreadyExists() method

        async sendOPT() {
            try {
                let phoneNumber =
                    this.$store.state.registration.form.contactInfo.isdCode.replace(
                        /\+/g,
                        ''
                    ) +
                    this.$store.state.registration.form.contactInfo.phoneNumber
                let fullName =
                    this.$store.state.registration.form.basicInfo.firstName
                let email =
                    this.$store.state.registration.form.contactInfo.email
                let recieveOtpOption = ['sms', 'email']

                // let dataSegmentId = this.dataSegmentId

                this.$store.commit('setLoading', true)

                const formData = {
                    mobileNo: phoneNumber,
                    name: fullName,
                    email: email,
                    recieveOtpOption: recieveOtpOption,
                }

                // console.log('PHONE NUMBER: ' + phoneNumber)

                const { data } = await request({
                    url: `/configurations/generate-otp/`,
                    method: 'post',
                    data: formData,
                })
                // console.log("dataOTPGET ", JSON.stringify(data));
                if (data) {
                    data.data.phoneNumber = phoneNumber
                    this.otpData = data

                    this.$refs.otpmodal.show()
                }

                // this.showPageLoader = false
                // console.log('Response OTP data: ' + JSON.stringify(data))
                // this.fields = data.data
            } catch (error) {
                const msg = typeof error == 'string' ? error : '';
                const response = error.response;
                if(response && response.data) {
                    let msg = response.data.message ? response.data.message : msg;
                }
                if(msg) {
                    this.$store.commit('setError', msg)
                }
                // console.log('OTP error: ' + error)
            }

            this.$store.commit('setLoading', false)
        }, // End of sendOtp() method

        async otpResponse(data, otp) {
            console.log("emi otp data: " + JSON.stringify(data));

            this.$store.commit('setLoading', true)

            if (data.verificationStatus == true) {
                this.$store.commit('setLoading', true)

                this.formData.otpCode = otp
                this.$store.commit('updateField', {
                    key: 'otpCode',
                    value: otp,
                })

                this.registerTempCustomer()
                // this.$store.commit('setLoading', false)
            } else {
                this.$store.commit('setError', data.message)
                this.$store.commit('setLoading', false)
            }
        },

        async reSendOTP() {
            this.sendOPT()
        }, // End of reSendOTP() method

        onCloseOTPModal() {
            this.$store.commit('setLoading', false)
        }, // End of pnCloseOTPModal() method
        closeMessageModal() {
            this.$refs.alreadyRegisteredModal.hide()
        }, // End of pnCloseOTPModal() method
    },
    // End of Component > mounted
}
</script>
